#import "../fragments/domain-fragment.graphql"

mutation AddSubdomain($subdomainAdd: SubdomainAddInput!) {
    subdomainAdd(input: $subdomainAdd) {
        domain {
            ...DomainFragment
        }
    }
}
